import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaCamera, FaHeart, FaUsers, FaAward, FaArrowRight } from 'react-icons/fa';
import IconWrapper from './IconWrapper';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about-page">
      {/* HERO */}
      <div className="about-hero">
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h1 className="about-title">O mně</h1>
            <p className="about-subtitle">
              Zachycuji skutečné emoce a příběhy, které si chcete pamatovat navždy.
            </p>
          </motion.div>
        </Container>
      </div>

      {/* MAIN CONTENT */}
      <Container className="py-5">
        <Row className="g-4 align-items-stretch">
          {/* FOTO */}
          <Col md={5} className="d-flex">
            <Card className="about-photo-card flex-fill h-100">
              <Card.Body className="d-flex align-items-center justify-content-center">
                <img
                  src="/images/about_me.jpg"
                  alt="Ivana – fotografka"
                  className="about-photo"
                />
              </Card.Body>
            </Card>
          </Col>

          {/* TEXT */}
          <Col md={7} className="d-flex">
            <Card className="about-text-card flex-fill h-100">
              <Card.Body className="d-flex flex-column justify-content-center">
                <div>
                  <p>
                    Fotografování se stalo mou vášní už před více než sedmnácti lety a od té doby
                    je pro mě nejen prací, ale i radostí a posláním. Nejčastěji fotím svatby,
                    rodiny, děti ve školkách a školách i různé společenské akce. Každé focení
                    vnímám jako jedinečný příběh, který si zaslouží být uchován v obrazech.
                  </p>
                  <p>
                    Mým cílem je zachytit skutečné emoce a opravdové okamžiky štěstí – radostný
                    smích, něžný pohled, dojetí i drobné detaily, které dělají život krásným.
                    Věřím, že fotografie mají moc vracet nás zpět k těmto chvílím a znovu nám
                    připomínat jejich kouzlo.
                  </p>
                  <p>
                    To, co mi lidé často říkají, je, že oceňují můj přístup – snažím se, aby se
                    každý cítil přirozeně a příjemně. Atmosféra při focení je pro mě stejně
                    důležitá jako samotný výsledek, protože právě díky uvolněnosti vznikají ty
                    nejkrásnější snímky.
                  </p>
                  <p>
                    Kromě samotného focení vedu také kurzy pro začínající fotografy. Baví mě
                    předávat své zkušenosti dál a vidět, jak lidé objevují radost z tvorby. A
                    obrovskou motivací jsou pro mě milé recenze a zpětné vazby, které dostávám po
                    každém focení – potvrzují mi, že má práce má smysl a přináší lidem radost.
                  </p>

                  <div className="mt-4">
                    <Button as="a" href="/contact" variant="primary" size="lg">
                      Domluvme si focení <IconWrapper icon={FaArrowRight} className="ms-2" />
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About;